import { RemoteRecordCleanUpAction } from '@client/common/redux/effects/createRemoteRecordCleanUpSaga';
import { RemoteRecord } from '@client/common/redux/RemoteRecord';
import { RemoteRecordData } from '@client/common/redux/RemoteRecordData';
import { AppState } from '@client/common/redux/store';
import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DetailedOrderType } from 'b2b-common/core/account/api/orders';
import { PDF_CATEGORY, PdfType } from 'b2b-common/core/account/api/Pdf.types';

const NAME = 'pdf';

export const pdfSlice = createSlice({
  name: NAME,
  reducerPath: NAME,
  initialState: {},
  reducers: {
    fetchPdf: (state, action: PayloadAction<{
      category: PDF_CATEGORY;
      id: string;
    }>) => {
      state[action.payload.id] = RemoteRecordData.init();
      return state;
    },
    fetchPdfFulfilled: (state, action: PayloadAction<{
      category: string;
      id: string;
      data: PdfType;
    }>) => {
      state[action.payload.id] = RemoteRecordData.fulfill(
        action.payload.data,
      );
    },
    fetchPdfRejected: (state, action: PayloadAction<{
      id: string;
      error: ErrorType;
    }>) => {
      state[action.payload.id] = RemoteRecordData.reject(
        action.payload.error,
      );
    },
    fetchPdfCleanUp: (state, action: RemoteRecordCleanUpAction<DetailedOrderType>) => action.payload.records,
    removePdf: (state, action: PayloadAction<string>) => {
      delete state[action.payload];
      return state;
    },
  },
});

export const {
  fetchPdf,
  fetchPdfFulfilled,
  fetchPdfRejected,
  fetchPdfCleanUp,
  removePdf,
} = pdfSlice.actions;


const getState = (state: AppState) => state.myAccount.pdf;

export const selectPdfRecords = createSelector(
  [getState],
  (state) => state,
);

export const selectPdf = createSelector(
  [getState, (state, id: string) => id],
  (state, id) => new RemoteRecord<PdfType>(state[id]),
);
